module.exports = __webpack_public_path__ + "img/10_16.742cc147.png";